import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const kpiApi = axios.create({
  baseURL: '/user-kpi-api', // Use relative path for KPI service

  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: set the token dynamically
kpiApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt');

    // Create a new config object to avoid directly mutating the parameter
    const newConfig = { ...config, headers: { ...config.headers } };

    if (token) {
      // KPI service expects Bearer tokens
      const tokenValue = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      newConfig.headers.Authorization = tokenValue;
    }
    return newConfig;
  },
  (error) => Promise.reject(error),
);

kpiApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect to auth page on 401 errors
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  },
);
